import type { HTMLAttributes } from 'react';
import styles from './Card.module.css';

export interface CardProps extends HTMLAttributes<HTMLElement> {
  as?: 'section' | 'div' | 'article' | 'li';
  padding?: 'none' | 'sm' | 'md' | 'lg';
}

/**
 * A grouped surface on the grey background (iOS "inset grouped"): no border,
 * no shadow. Groups related content; it is not decoration.
 */
export function Card({ as: Element = 'section', padding = 'md', className, ...rest }: CardProps) {
  return (
    <Element
      className={[styles.card, styles[`padding-${padding}`], className].filter(Boolean).join(' ')}
      {...rest}
    />
  );
}
